The details of the `CandidateProcessHistoryItem` to be deleted.
